// Imports for external libraries go here.
import React, { FC } from 'react';

// Imports for internal (to the monorepo) libraries go here,
// separated by a blank line from external imports.
// The closer the import is to the file the lower it should be in this list.
import { HeaderSectionProps } from './HeaderSection.types';
import { StyledHeaderSection } from './HeaderSection.styles';
import { Heading, size, tags, Types } from '@marriott/mi-ui-library';
import { LegalTextWithLink } from '../LegalTextWithLink';

// Use named rather than default exports.
export const HeaderSection: FC<HeaderSectionProps> = props => {
  const {
    heading,
    subHeading,
    description,
    headerContainerClassName,
    headingClass,
    subHeadingClass,
    headerFontSize,
    headerTextStyle,
    subHeaderTextStyle,
    subHeaderFontSize,
    descriptionClass,
    onLinkClickInHeader,
  } = props;

  const getHeaderOrSubHeaderFontSize = (fontSize: string | undefined) => {
    if (fontSize === 'xs') return size.extraSmall;
    if (fontSize === 's') return size.small;
    if (fontSize === 'l') return size.large;

    return size.medium;
  };

  const getHeaderOrSubHeaderTextStyle = (textStyle: string | undefined) => {
    if (textStyle === 'h1') return tags.h1;
    if (textStyle === 'h3') return tags.h3;
    if (textStyle === 'h4') return tags.h4;
    if (textStyle === 'h5') return tags.h5;
    if (textStyle === 'h6') return tags.h6;

    return tags.h2;
  };
  return (
    <StyledHeaderSection
      onClick={onLinkClickInHeader}
      data-testid="legal-HeaderSectionProps"
      data-component-name="m-legal-HeaderSectionProps"
      className={headerContainerClassName || ''}
    >
      {heading && (
        <Heading
          variation={Types.headingType.title}
          fontSize={getHeaderOrSubHeaderFontSize(headerFontSize)}
          element={getHeaderOrSubHeaderTextStyle(headerTextStyle)}
          titleText={heading}
          disableCustomClickTrack={true}
          customClass={headingClass || ''}
        />
      )}

      {subHeading && (
        <Heading
          variation={Types.headingType.subtitle}
          fontSize={getHeaderOrSubHeaderFontSize(subHeaderFontSize)}
          element={getHeaderOrSubHeaderTextStyle(subHeaderTextStyle)}
          titleText={subHeading}
          disableCustomClickTrack={true}
          customClass={subHeadingClass || ''}
        />
      )}
      {description && <LegalTextWithLink className={descriptionClass || ''} descriptionText={description} />}
    </StyledHeaderSection>
  );
};
